import {storeInstance} from '@aofl/store/dist/legacy';
import {sdoNs, levelRestrictedPermissions, permissionsReverseMap, levelExcludedPermissions} from './constants-enumerate';
import {ThreeWayToggle} from './three-way-toggle';

const getAbsIndex = (length, index) => {
  const len = parseInt(length, 10);
  return (len + parseInt(index, 10)) % len;
};

const hasOneOfPermissions = (permissions) => {
  if (!Array.isArray(permissions)) {
    console.error('hasOneOfPermissions permissions must be passed in as an array', permissions);
  }

  const state = storeInstance.getState();
  const role = state[sdoNs.SESSION].current_role;
  return hasPermissionForRole(permissions, role);
};

const isReadOnly = () => {
  const state = storeInstance.getState();
  const role = state[sdoNs.SESSION].current_role;
  for (const key in role.access_data) {
    if (role.access_data[key] === true && key !== 'read') {
      return false;
    }
  }
  return role.access_data.read || false;
};

const hasPermissionForRole = (permissions, role) => {
  const userPermission = role.access_data;
  if (userPermission.all === true) {
    if (permissions.length === 1
      && (permissions[0] === permissions.SPONSOR && !userPermission.sponsor)
          || (permissions[0] === permissions.HIDE_STUDENT && !userPermission.hide_student)
    ) {
      return false;
    }
    return true;
  }

  for (const key in permissions) {
    if (!permissions.hasOwnProperty(key)) continue;
    const permission = permissions[key];

    if (userPermission[permission] === true) {
      return true;
    }
  }
  return false;
};

const restrictedPermissions = (level, levels) => {
  const targetLevel = parseInt(level, 10);
  const permissions = [];

  for (let i = 0; i <= targetLevel; i++) {
    const key = String(i);
    if (typeof levelRestrictedPermissions[key] !== 'undefined') {
      permissions.push(...levelRestrictedPermissions[key]);
    }
  }

  for (const key in levelExcludedPermissions) {
    if (!Object.prototype.hasOwnProperty.call(levelExcludedPermissions, key)) continue;
    const excludedLevel = getAbsIndex(levels, key) + 1;
    if (excludedLevel === parseInt(level, 10)) {
      permissions.push(...levelExcludedPermissions[key]);
    }
  }

  return permissions;
};

const rolesToGrouped = (accessData) => {
  const permissions = {};
  const permissionValue = {};
  try {
    for (const key in accessData) {
      if (!accessData.hasOwnProperty(key)) continue;
      const permission = accessData[key];
      const group = permissionsReverseMap[key];

      if (typeof group === 'undefined') continue;

      for (let index in group) {
        if (typeof permissions[group[index]] === 'undefined') {
          permissionValue[group[index]] = permission;
          permissions[group[index]] = {
            toggleState: permission? ThreeWayToggle.VALUES.ALL: ThreeWayToggle.VALUES.NONE,
            permissions: {}
          };
        }

        permissions[group[index]].permissions[key] = permission;
        if (permission !== permissionValue[group[index]]) {
          permissions[group[index]].toggleState = ThreeWayToggle.VALUES.SOME;
        }
      }
    }
  } catch (e) {
    console.error(e); // eslint-disable-line no-console
  }

  return permissions;
};

export {
  hasOneOfPermissions,
  hasPermissionForRole,
  restrictedPermissions,
  rolesToGrouped,
  isReadOnly
};
